import React from 'react';
import classnames from 'classnames';
import { Bubble, BubbleProps } from 'tea-component';
import { isEmpty } from '@gp/utils/common';
import { getMetricInfoListUI } from '@gp/utils/metricTips';

import './index.scss';

type IFieldValue = string | React.ReactElement | null | undefined;

interface IMultipleLinesTextCfg {
  // 字段从上到下的排列顺序
  fields: string[];
  // 字段名称的映射
  names?: Record<string, IFieldValue>;
  // 字段于字段value的映射
  data: Record<string, IFieldValue>;
}

interface IMultipleLinesTextBubbleProps extends BubbleProps, IMultipleLinesTextCfg {}

const isNoData = (cfg: IMultipleLinesTextCfg): boolean => {
  const { fields, data } = cfg || {};
  if (!Array.isArray(fields) || !fields.length) return true;
  if (!data || !Object.keys(data).length) return true;
  return Object.values(data).every((it) => isEmpty(it));
};

const MultipleLinesTextBubble: React.FC<IMultipleLinesTextBubbleProps> = (props) => {
  const {
    style,
    className,
    fields,
    names,
    data,
    arrowPointAtCenter = true,
    dark = true,
    children,
    ...restProps
  } = props;

  if (isNoData({ fields, data })) return children as React.ReactElement;

  return (
    <Bubble
      {...restProps}
      className={classnames('dbg-multiple-lines-text-bubble dbg-bubble-max-width', className)}
      dark={dark}
      arrowPointAtCenter={arrowPointAtCenter}
      content={getMetricInfoListUI(fields, names, data)}
    >
      {/* @ts-ignore */}
      {React.cloneElement(children, {
        // @ts-ignore
        style: { ...children?.props?.style, cursor: 'pointer' },
      })}
    </Bubble>
  );
};

export default MultipleLinesTextBubble;
